import { render, staticRenderFns } from "./ArtistBiographyAccordion.vue?vue&type=template&id=abf13790&"
import script from "./ArtistBiographyAccordion.vue?vue&type=script&lang=js&"
export * from "./ArtistBiographyAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports